<template>
  <div
    v-if="hasAnySubsidyFlags"
    class="col-alignment d-flex flex-wrap"
    data-testid="computedSubsidyFlags"
  >
    <v-chip
      v-if="enrollment?.meta?.computed_subsidy_flags?.iep"
      class="ma-1"
      color="primary"
      size="x-small"
      variant="tonal"
    >
      {{ $bct('Individualized education plan') }}
    </v-chip>

    <v-chip
      v-if="enrollment?.meta?.computed_subsidy_flags?.current_provider"
      :variant="enrollment?.current_provider_verified ? 'flat' : 'tonal'"
      class="ma-1"
      color="primary"
      size="x-small"
    >
      <v-icon
        v-if="enrollment?.current_provider_verified"
        class="mr-1"
        icon="check_circle_outline"
        size="small"
      />
      {{ $bct('Current student') }}
    </v-chip>

    <v-chip
      v-if="enrollment?.meta?.computed_subsidy_flags?.sibling_provider"
      :variant="enrollment?.sibling_provider_verified ? 'flat' : 'tonal'"
      class="ma-1"
      color="primary"
      size="x-small"
    >
      <v-icon
        v-if="enrollment?.sibling_provider_verified"
        class="mr-1"
        icon="check_circle_outline"
        size="small"
      />
      {{ $bct('Sibling of student') }}
    </v-chip>

    <v-chip
      v-if="enrollment?.meta?.computed_subsidy_flags?.staff_provider"
      :variant="enrollment?.staff_provider_verified ? 'flat' : 'tonal'"
      class="ma-1"
      color="primary"
      size="x-small"
    >
      <v-icon
        v-if="enrollment?.staff_provider_verified"
        class="mr-1"
        icon="check_circle_outline"
        size="small"
      />
      {{ $bct('Family is staff') }}
    </v-chip>
  </div>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  enrollment: {
    type: Object,
    default: null,
  },
});

const hasAnySubsidyFlags = computed(() => {
  const { computed_subsidy_flags: computedSubsidyFlags } = props.enrollment?.meta || {};

  return (
    computedSubsidyFlags?.current_provider ||
    computedSubsidyFlags?.sibling_provider ||
    computedSubsidyFlags?.staff_provider ||
    computedSubsidyFlags?.iep
  );
});
</script>
